import styled from '@emotion/styled';

export const StyledFlexColumnsWrapper = styled.main`
  width: 100%;
  table {
    tr[data-highlight='deactivated' i] {
      td {
        background-color: #fafafa;
        color: #999999;
      }
    }

    td > u {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      :hover {
        color: #7fe200;
      }
      b {
        color: #7fe200;
      }
      & > div {
        margin-left: 6px;
        background-color: #ffffff;
      }
      &:hover > div {
        border-color: #7fe200;
        background-color: #effdda;
        :before,
        :after {
          border-color: #7fe200;
        }
      }
      &:active > div {
        border-color: #7fe200;
        background-color: #7fe200;
        :before,
        :after {
          border-color: #ffffff;
        }
      }
    }
  }
`;

export const StyledSearchBarWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div:nth-of-type(1) {
    margin-left: 0;
  }
`;

export const StyledCreateAccountButton = styled.div`
  display: inline-block;
  border-radius: 50px;
  font-family: Noto Sans KR;
  font-weight: 700;
  font-style: normal;
  font-size: 18px;
  background-color: #00bf00;
  color: white;
  padding: 0 40px;
  height: 40px;
  line-height: 40px;
  min-width: 129px;
  &:hover {
    cursor: pointer;
    background-color: #7fe200;
  }
  &:active {
    background-color: #00bf00;
  }
`;
